import { render, staticRenderFns } from "./VxTooltipCustom.vue?vue&type=template&id=c6715b74"
import script from "./VxTooltipCustom.vue?vue&type=script&lang=js"
export * from "./VxTooltipCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports